import { render, staticRenderFns } from "./exammanage.vue?vue&type=template&id=41c05019&scoped=true"
import script from "./exammanage.vue?vue&type=script&lang=js"
export * from "./exammanage.vue?vue&type=script&lang=js"
import style0 from "./exammanage.vue?vue&type=style&index=0&id=41c05019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c05019",
  null
  
)

export default component.exports